import CarScene from "./components/CarScene";
import { Nameplate, usePaint } from "./components/CarShowcase";
import StatusBar from "./components/StatusBar";
import Deck from "./components/Deck";
import { useCarState } from "./state/useCarState";
import { useCarSounds } from "./state/useCarSounds";
import { DEMO_MODE } from "./supabaseClient";

// Single-screen deck: header · car hero · status strip · category tabs · controls. No page scroll.
export default function App() {
  const { state, send, busy, toasts, setDemoInput } = useCarState();
  const [paint, setPaint] = usePaint();
  useCarSounds(state);

  return (
    <div className="app">
      <div className="bg-grid" />
      <header className="hd">
        <Nameplate />
        <div className="hd-right">
          <div className={`hd-mode ${DEMO_MODE ? "demo" : "live"}`}>{DEMO_MODE ? "DEMO" : "LIVE"}</div>
          {DEMO_MODE && (
            <div className="demo-toggles">
              <label><input type="checkbox" checked={state.neutral} onChange={(e) => setDemoInput({ neutral: e.target.checked })} /> N</label>
              <label><input type="checkbox" checked={state.handbrake} onChange={(e) => setDemoInput({ handbrake: e.target.checked })} /> HB</label>
            </div>
          )}
        </div>
      </header>

      <section className="hero">
        <CarScene s={state} paint={paint} />
      </section>

      <StatusBar s={state} />

      <Deck s={state} send={send} busy={busy} paint={paint} setPaint={setPaint} onAbort={() => send("abort")} setDemoInput={setDemoInput} />

      <div className="toasts">
        {toasts.map((t) => (
          <div key={t.id} className={`toast toast-${t.kind}`}>{t.text}</div>
        ))}
      </div>
    </div>
  );
}
